import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from '@/components/forms/new/formikFormFields/BooleanToggle';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import { getBillingFieldPaths, getBillingSettings } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const ItemInvoiceToggle = ({ darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);

    const { formData, updateFormData, mode } = useCompanyForm();
    const billingFieldPaths = getBillingFieldPaths(mode);
    const billingSettings = getBillingSettings(formData, mode);

    const handleToggleChange = (value) => {
        updateFormData(billingFieldPaths.BILL_ONE_LINE, value);
    };

    return (
        <>
            <FormControl
                sx={{ margin: '0 !important' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    sx={{ ...stackStyling(), height: 'auto' }}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Single Item Invoice
                    </FormLabel>
                    <Box flex={1} maxWidth="400px">
                        <Field
                            component={BooleanToggle}
                            id="isActive"
                            name="isActive"
                            paddingTop="20px"
                            isChecked={billingSettings?.billOneLine ?? false}
                            onChange={handleToggleChange}
                        />
                        {isHovered && (
                            <FieldToolTip
                                label="Show invoice as single line item"
                                ariaLabel="active-status-tip"
                                left="25px"
                            />
                        )}
                    </Box>
                </Stack>
            </FormControl>
        </>
    );
};

export default ItemInvoiceToggle;
